module.exports = __webpack_public_path__ + "static/media/NIP.51ac9c00.svg";